import React, { Component } from "react";
import "../../static/css/styles.css";
import { constants } from "../../Constants";

let currentYear = new Date().getFullYear();
class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="footer">
          <div className="text-center">
            <a
              data-content={constants.EMAIL}
              href={`mailto:${constants.EMAIL}`}
              data-type="mail"
              className="footer-text-a"
            >
              {constants.EMAIL}
            </a>
          </div>
          <div className="text-center">
            <label className="footer-text">
             {constants.WHATSAPP_SUPPORT_TEXT} - {constants.WHATSAPP_SUPPORT}
            </label>
          </div>
          <div className="text-center">
            <label className="footer-text">
              {constants.COPYRIGHT_TEXT} &copy; {constants.SAAYA_HEALTH_TXT} {currentYear}
            </label>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/footer.js